/* eslint-disable no-restricted-imports */
import {ImageURL, LobbyImage} from '@colonist/types'
import {UIImagePathController} from '../../../../../code/client/shared/scripts/UIEnums'
import {TranslationObject} from '@colonist/i18n'
import StatProposedTrades from '@static/images/stat_proposed_trades.svg'
import StatSuccessfulTrades from '@static/images/stat_successful_trades.svg'
import StatResourcesUsed from '@static/images/stat_resources_used.svg'
import StatResourceIncomeBlocked from '@static/images/stat_resource_income_blocked.svg'
import StatDevCardBought from '@static/images/stat_dev_card_bought.svg'
import StatDevCardUsed from '@static/images/stat_dev_card_used.svg'
import StatResGain from '@static/images/stat_res_gain.svg'
import StatResLoss from '@static/images/stat_res_loss.svg'
import StatResScore from '@static/images/stat_res_score.svg'
import StatRollingIncome from '@static/images/stat_rolling_income.svg'
import StatRobbingIncome from '@static/images/stat_robbing_income.svg'
import StatDevCardIncome from '@static/images/stat_dev_card_income.svg'
import StatTradeIncome from '@static/images/stat_trade_income.svg'
import StatRollingLoss from '@static/images/stat_rolling_loss.svg'
import StatRobbingLoss from '@static/images/stat_robbing_loss.svg'
import StatDevCardLoss from '@static/images/stat_dev_card_loss.svg'
import StatTradeLoss from '@static/images/stat_trade_loss.svg'
import StatGoldIncome from '@static/images/stat_gold_income.svg'

export const ACTIVITY_IMAGE_PATH: Record<string, ImageURL> = {
    proposedTrades: StatProposedTrades,
    successfulTrades: StatSuccessfulTrades,
    resourcesUsed: StatResourcesUsed,
    resourceIncomeBlocked: StatResourceIncomeBlocked,
    devCardsBought: StatDevCardBought,
    devCardsUsed: StatDevCardUsed,
}

export const ACTIVITY_TRANSLATION: Record<string, {
    title: TranslationObject
}> = {
    proposedTrades: {
        title: {key: 'strings:game.endGame.activity.proposedTrades'},
    },
    successfulTrades: {
        title: {key: 'strings:game.endGame.activity.successfulTrades'},
    },
    resourcesUsed: {
        title: {key: 'strings:game.endGame.activity.resourcesUsed'},
    },
    resourceIncomeBlocked: {
        title: {key: 'strings:game.endGame.activity.resourceIncomeBlocked'},
    },
    devCardsBought: {
        title: {key: 'strings:game.endGame.activity.devCardsBought'},
    },
    devCardsUsed: {
        title: {key: 'strings:game.endGame.activity.devCardsUsed'},
    },
}

export const RESOURCE_ACTIVITY_IMAGE_PATH: Record<string, ImageURL> = {
    totalResourceIncome: StatResGain,
    totalResourceLoss: StatResLoss,
    totalResourceScore: StatResScore,
    rollingIncome: StatRollingIncome,
    robbingIncome: StatRobbingIncome,
    devCardIncome: StatDevCardIncome,
    tradeIncome: StatTradeIncome,
    rollingLoss: StatRollingLoss,
    robbingLoss: StatRobbingLoss,
    devCardLoss: StatDevCardLoss,
    tradeLoss: StatTradeLoss,
    goldIncome: StatGoldIncome,
}

export const RESOURCE_ACTIVITY_TRANSLATION: Record<string, {
    title: TranslationObject
}> = {
    totalResourceIncome: {
        title: {key: 'strings:game.endGame.resource.totalResourceIncome'},
    },
    totalResourceLoss: {
        title: {key: 'strings:game.endGame.resource.totalResourceLoss'},
    },
    totalResourceScore: {
        title: {key: 'strings:game.endGame.resource.totalResourceScore'},
    },
    rollingIncome: {
        title: {key: 'strings:game.endGame.resource.rollingIncome'},
    },
    robbingIncome: {
        title: {key: 'strings:game.endGame.resource.robbingIncome'},
    },
    devCardIncome: {
        title: {key: 'strings:game.endGame.resource.devCardIncome'},
    },
    tradeIncome: {
        title: {key: 'strings:game.endGame.resource.tradeIncome'},
    },
    rollingLoss: {
        title: {key: 'strings:game.endGame.resource.rollingLoss'},
    },
    robbingLoss: {
        title: {key: 'strings:game.endGame.resource.robbingLoss'},
    },
    devCardLoss: {
        title: {key: 'strings:game.endGame.resource.devCardLoss'},
    },
    tradeLoss: {
        title: {key: 'strings:game.endGame.resource.tradeLoss'},
    },
    goldIncome: {
        title: {key: 'strings:game.endGame.resource.goldIncome'},
    },
}

export const AD_BOX_CONTENT: {title: TranslationObject, image: ImageURL, isRemoveAdContent?: boolean}[] = [
    {
        title: {key: 'strings:game.gameEndItem.defeatBarbarians'},
        image: UIImagePathController.getImgPath(LobbyImage.StoreItemCitiesAndKnights4P),
    }, {
        title: {key: 'strings:game.gameEndItem.useSpecialBuild'},
        image: UIImagePathController.getImgPath(LobbyImage.StoreItemExpansionClassic78P),
    }, {
        title: {key: 'strings:game.gameEndItem.discoverRandomHexes'},
        image: UIImagePathController.getImgPath(LobbyImage.MapSS3FogIslands4PPreview),
    }, {
        title: {key: 'strings:colonistCommon.utils.emptyString'},
        image: UIImagePathController.getImgPath(LobbyImage.StoreMembershipPerkNoAdsGifDesertHex),
        isRemoveAdContent: true,
    }, {
        title: {key: 'strings:colonistCommon.utils.emptyString'},
        image: UIImagePathController.getImgPath(LobbyImage.StoreMembershipPerkNoAdsGifDesertBox),
        isRemoveAdContent: true,
    }, {
        title: {key: 'strings:colonistCommon.utils.emptyString'},
        image: UIImagePathController.getImgPath(LobbyImage.StoreMembershipPerkNoAdsGifGoldHex),
        isRemoveAdContent: true,
    }, {
        title: {key: 'strings:colonistCommon.utils.emptyString'},
        image: UIImagePathController.getImgPath(LobbyImage.StoreMembershipPerkNoAdsGifGoldBox),
        isRemoveAdContent: true,
    },
]

export const FADE_IN_ANIMATION_DELAYS = {
    transitionDuration: 1000,
    ads: 2000,
    logo: 1000,
    topLeftButtons: 2000,
    content: 3000,
    contentRankedGame: 0,
    footerRankedGame: 0,
    footer: 4000,
}

